export enum CalculationFunction {
    RAW = 'RAW',
    MIN = 'MIN',
    MAX = 'MAX',
    AVERAGE = 'AVERAGE',

}
